import React from 'react';
import { Tooltip } from '@mui/material';
import AccurityIcon from '../../../icon/components/AccurityIcon';
var NodeContent = function (_a) {
    var label = _a.label, icon = _a.icon;
    return (React.createElement("div", { className: 'nodeContent' },
        React.createElement(AccurityIcon, { iconName: icon, fontSize: "small", className: 'nodeContent__icon' }),
        React.createElement(Tooltip, { title: label },
            React.createElement("span", { className: 'nodeContent__label' }, label))));
};
export default NodeContent;
//# sourceMappingURL=NodeContent.js.map